import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: process.env.FIREBASE_KEY,
    authDomain: "college-connect-924e9.firebaseapp.com",
    databaseURL: "https://college-connect-924e9-default-rtdb.firebaseio.com",
    projectId: "college-connect-924e9",
    storageBucket: "college-connect-924e9.appspot.com",
    messagingSenderId: "36767684678",
    appId: "1:36767684678:web:8da9f88a6caf4e6c0c5247",
    measurementId: "G-3JGY5N7KXW"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);